module.exports = __webpack_public_path__ + "img/jed_in_hour_glass.ab1851df.jpg";